import engineers from "./engineers";

export default {
    namespaced: true,
    modules: {
        engineers
    }
};